import cx from 'classnames'

const avatarTones = new Set(['dormant', 'member', 'you'])

export const Avatar = ({ className, label = '', muted = false, size = 'md', tone = 'member', ...props }) => {
  const dimensions = size === 'sm' ? 'tw:h-9 tw:w-9 tw:text-sm' : 'tw:h-11 tw:w-11 tw:text-base'
  const resolvedTone = muted ? 'dormant' : avatarTones.has(tone) ? tone : 'member'

  return (
    <span
      aria-hidden="true"
      className={cx(
        'ds-avatar tw:inline-flex tw:shrink-0 tw:items-center tw:justify-center tw:rounded-full tw:font-semibold',
        dimensions,
        className,
      )}
      data-tone={resolvedTone}
      {...props}
    >
      {label || '?'}
    </span>
  )
}
